import {
  FETCH_STATIC_PAGE_START,
  FETCH_STATIC_PAGE_SUCCESS,
  FETCH_STATIC_PAGE_FAILURE,
  FETCH_FAQS_LIST_START,
  FETCH_FAQS_LIST_SUCCESS,
  FETCH_FAQS_LIST_FAILURE,
  CONTACT_FORM_START,
  CONTACT_FORM_SUCCESS,
  CONTACT_FORM_FAILURE,
} from "../actions/ActionConstant";

const initialState = {
  pageData: {
    data: {},
    loading: true,
    error: false,
  },
  faqsList: {
    data: {},
    loading: true,
    error: false,
  },
  contactForm: {
    data: {},
    loading: true,
    buttonDisable: false,
    error: false,
  },
};

const PageReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_STATIC_PAGE_START:
      return {
        ...state,
        pageData: {
          data: {},
          loading: true,
          error: false,
        },
      };
    case FETCH_STATIC_PAGE_SUCCESS:
      return {
        ...state,
        pageData: {
          data: action.data,
          loading: false,
          error: false,
        },
      };
    case FETCH_STATIC_PAGE_FAILURE:
      return {
        ...state,
        pageData: {
          data: {},
          loading: false,
          error: action.error,
        },
      };
    case FETCH_FAQS_LIST_START:
      return {
        ...state,
        faqsList: {
          data: {},
          loading: true,
          error: false,
        },
      };
    case FETCH_FAQS_LIST_SUCCESS:
      return {
        ...state,
        faqsList: {
          data: action.data,
          loading: false,
          error: false,
        },
      };
    case FETCH_FAQS_LIST_FAILURE:
      return {
        ...state,
        faqsList: {
          data: {},
          loading: false,
          error: action.error,
        },
      };

    case CONTACT_FORM_START:
      return {
        ...state,
        contactForm: {
          data: {},
          loading: true,
          buttonDisable: true,
          error: false,
        },
      };
    case CONTACT_FORM_SUCCESS:
      return {
        ...state,
        contactForm: {
          data: action.data,
          loading: false,
          error: false,
          buttonDisable: false,
          responseData: action.responseData,
        },
      };
    case CONTACT_FORM_FAILURE:
      return {
        ...state,
        contactForm: {
         data: {},
          loading: false,
          buttonDisable: false,
          error: action.error,
        },
      };
    

    default:
      return state;
  }
};

export default PageReducer;
